import axios, { AxiosInstance } from 'axios';
import * as API from '../../../constants/API';
import { BarthelRecord } from '../../../constants/Records';

export class BarthelApiClient {
  private api: AxiosInstance;

  static async ClientFactory(): Promise<BarthelApiClient> {
    return new BarthelApiClient();
  }

  constructor() {
    const apiKey = process.env.REACT_APP_BARTHEL_API_KEY || '';

    this.api = axios.create({
      baseURL: API.barthelApiRoot,
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
    });
  }

  // 特定日のレコード取得
  async getRecord(uniqueId: string, date: string): Promise<BarthelRecord> {
    const res = await this.api.get(`/barthel/${uniqueId}/date/${date}`);
    return res.data;
  }

  // 期間指定取得
  async getRecordsByDateRange(uniqueId: string, from: string, to: string): Promise<BarthelRecord[]> {
    const res = await this.api.get(`/barthel/${uniqueId}/from/${from}/to/${to}`);
    return res.data;
  }

  // 最新レコード取得
  async getLatestRecord(uniqueId: string): Promise<BarthelRecord> {
    const res = await this.api.get(`/latest/${uniqueId}`);
    return res.data;
  }

  // レコード作成
  async createRecord(data: Partial<BarthelRecord>): Promise<BarthelRecord> {
    const res = await this.api.post('/barthel', data);
    return res.data;
  }

  // レコード更新
  async updateRecord(uniqueId: string, date: string, data: Partial<BarthelRecord>): Promise<BarthelRecord> {
    const res = await this.api.put(`/barthel/${uniqueId}/date/${date}`, data);
    return res.data;
  }

  // レコード削除
  async deleteRecord(uniqueId: string, date: string): Promise<void> {
    await this.api.delete(`/barthel/${uniqueId}/date/${date}`);
  }
}
